import imageUrlBuilder from '@sanity/image-url';

import { client } from '@tac/sanity-client/client';

import type { SanityImageSource } from '@sanity/image-url/lib/types/types';

const builder = imageUrlBuilder(client);

export const urlFor = (source?: SanityImageSource | null) => {
  if (!source) return;

  return builder.image(source);
};
